import { Injectable, InjectionToken, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MenuItem } from '../layout/models/menu-item.interface';

export interface MenuConfig {
  menuItems: MenuItem[];
  appName: string;
}

export const MENU_CONFIG = new InjectionToken<MenuConfig>('MenuConfig');

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menuItems: MenuItem[];
  private appName: string;

  constructor(@Inject(MENU_CONFIG) config: MenuConfig) {
    this.menuItems = config.menuItems;
    this.appName = config.appName;
  }

  getMenuItems(): Observable<MenuItem[]> {
    return of(this.menuItems);
  }

  getIconForPath(path: string): string {
    const menuItem = this.menuItems.find(item => item.path === path);
    return menuItem?.icon || 'circle';
  }

  getAppName(): string {
    return this.appName;
  }
}
